export const formatEventForTTS = (item, language = 'EN') => {
  if (!item) return '';

  const name = item.event_name || item.place_name || '';

  const summary = item.event_summary || item.review_summary || item.summary || item.description || '';

  if (!name && !summary) {
    return '';
  }

  if (!summary) {
    return name;
  }

  return `${name}. ${summary}`;
};

export default formatEventForTTS;
